// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"tf_a bih_rc bih_qx bih_xr","ContestPosts__more":"tf_b bih_vu bih_b bih_va bih_sv"};